<ng-container
  *ngIf="{
    component: component$ | async,
    media: currentMedia$ | async,
  } as content"
>
  <ng-template #image>
    <img src="{{ content.media?.url | cxUrl }}" [alt]="content.media?.altText" class="w-100" [title]="content.media?.altText ?? ''" />
  </ng-template>

  @if (content.component.urlLink) {
    <cx-generic-link [url]="content.component?.urlLink!" [target]="content.component?.external ? '_blank' : ''">
      <ng-container *ngTemplateOutlet="image"></ng-container>
    </cx-generic-link>
  } @else {
    <ng-container *ngTemplateOutlet="image"></ng-container>
  }
</ng-container>
